import { type FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../auth/AuthContext.tsx'
import { NexOrganixLogo } from '../components/Bits.tsx'

export function LoginPage() {
  const { login, authenticated } = useAuthContext()
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (authenticated) {
    return (
      <div className="loginpage card card__pad">
        <p>Du är inloggad.</p>
        <button type="button" className="btn btn--primary" onClick={() => navigate('/simulering')}>
          Till simuleringen
        </button>
      </div>
    )
  }

  async function submit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(username.trim(), password)
      navigate('/simulering')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Inloggning misslyckades')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="loginpage">
      <div className="card card__pad">
        <NexOrganixLogo height={34} />
        <h1 style={{ marginTop: 14 }}>Logga in</h1>
        <p className="muted">Inloggning för behöriga.</p>
        <form onSubmit={submit} className="grid" style={{ gap: 14, maxWidth: 340 }}>
          <div className="field">
            <label htmlFor="u">Användarnamn</label>
            <input
              id="u"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="field">
            <label htmlFor="p">Lösenord</label>
            <input
              id="p"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="notice notice--error">{error}</div>}
          <button type="submit" className="btn btn--primary" disabled={busy}>
            {busy ? 'Loggar in …' : 'Logga in'}
          </button>
        </form>
      </div>
    </div>
  )
}
